export const MAX_DOMAIN_LENGTH = 252;
export const BASE_PATH = '/loy';
export const PARTICIPANT_AUTH_CALLBACK_PATH = '/l/auth/callback' as const;

export const encryptedSecretPlaceholder = '***';

export const defaultLevelImage = `${BASE_PATH}/assets/template/assets/images/level.png`;
export const defaultCurrencyImage = `${BASE_PATH}/assets/template/assets/images/currency.png`;
export const defaultProfileImage = `${BASE_PATH}/assets/template/assets/images/default_profile_image.png`;
export const defaultCampaignViralityImage = `${BASE_PATH}/assets/template/assets/images/default_campaign_virality_img.png`;

export const flagSvg = (isoCode: string) =>
  `${BASE_PATH}/assets/template/assets/flags/${isoCode}.svg`;

export const accountDomainRedirectUri = (domain: string, programId: string) =>
  `https://${domain}/l/${programId}/auth/callback`;
